import "./ToggleButton.scss";

import { FunctionComponent } from "react";

interface IProps {
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  checked: boolean | undefined;
  checkedText: string;
  uncheckedText: string;
  className?: string;
  name?: string;
  value?: string;
  disabled?: boolean;
}

const ToggleButton: FunctionComponent<IProps> = (props) => {
  const getWidth = () => {
    return `${
      Math.max(props.checkedText.length, props.uncheckedText.length) + 4
    }ch`;
  };

  return (
    <label
      style={{ minWidth: getWidth() }}
      className={
        "toggle-button " +
        props.className +
        " " +
        (props.checked ? "checked" : "") +
        (props.disabled ? " checkbox-disabled" : "")
      }
    >
      <input
        className="toggle-button__input"
        name={props.name}
        value={props.value}
        type="checkbox"
        onChange={props.onChange}
        checked={props.checked}
      />
      <span className="toggle-button__indicator"></span>
      <span className="toggle-button__text--checked">{props.checkedText}</span>
      <span className="toggle-button__text--unchecked">
        {props.uncheckedText}
      </span>
    </label>
  );
};

export default ToggleButton;
